import ascendDomestic from 'assets/images/brandLogos/domestic/AscendHotels600.png'
import cambriaDomestic from 'assets/images/brandLogos/domestic/cambria-BR-HO-R.png'
import clarionDomestic from 'assets/images/brandLogos/domestic/clarion-CL-HS-R.png'
import radissonDomestic from 'assets/images/brandLogos/domestic/Radisson600.png'
import radissonInternational from 'assets/images/brandLogos/international/RadissonTM600.png'
import comfortDomestic from 'assets/images/brandLogos/domestic/comfort.jpg'
import comfortSuitesDomestic from 'assets/images/brandLogos/domestic/ComfortSuites.jpg'
import econolodgeDomestic from 'assets/images/brandLogos/domestic/Econolodge.jpg'
import everhomeDomestic from 'assets/images/brandLogos/domestic/Everhome.jpg'
import mainstayDomestic from 'assets/images/brandLogos/domestic/MainStay.jpg'
import qualityDomestic from 'assets/images/brandLogos/domestic/Quality.jpg'
import rodewayDomestic from 'assets/images/brandLogos/domestic/Rodeway.jpg'
import sleepDomestic from 'assets/images/brandLogos/domestic/Sleep.jpg'
import suburbanDomestic from 'assets/images/brandLogos/domestic/Suburban.jpg'
import woodspringDomestic from 'assets/images/brandLogos/domestic/WoodSpring.jpg'
import ascendhotelcollectionInternational from 'assets/images/brandLogos/international/AscendHotels600.png'
import cambriaInternational from 'assets/images/brandLogos/international/cambria.jpg'
import clarionInternational from 'assets/images/brandLogos/international/clarion.jpg'
import econolodgeInternational from 'assets/images/brandLogos/international/econolodge.jpg'
import mainstayInternational from 'assets/images/brandLogos/international/mainstay.jpg'
import qualityInternational from 'assets/images/brandLogos/international/quality.jpg'
import rodewayinnInternational from 'assets/images/brandLogos/international/rodewayinn.jpg'
import sleepinnInternational from 'assets/images/brandLogos/international/sleepinn.jpg'

// Domestic Logos
import ascendDomACHO from 'assets/images/brandLogos/domestic/AscendHotels600.png'
import cambriaDomBRHO from 'assets/images/brandLogos/domestic/cambria-BR-HO-R.png'
import clarionDomCLAS from 'assets/images/brandLogos/domestic/clarion-CL-AS-R.png'
import clarionDomCLCC from 'assets/images/brandLogos/domestic/clarion-CL-CC-R.png'
import clarionDomCLHO from 'assets/images/brandLogos/domestic/clarion-CL-HO-R.png'
import clarionDomCLHS from 'assets/images/brandLogos/domestic/clarion-CL-HS-R.png'
import clarionDomCLIN from 'assets/images/brandLogos/domestic/clarion-CL-IN-R.png'
import clarionDomCLPT from 'assets/images/brandLogos/domestic/clarion-CL-PT-R.png'
import clarionDomCLSU from 'assets/images/brandLogos/domestic/clarion-CL-SU-R.png'
import comfortinnDomCIAS from 'assets/images/brandLogos/domestic/comfortinn-CI-AS-R.png'
import comfortinnDomCIHO from 'assets/images/brandLogos/domestic/comfortinn-CI-HO-R.png'
import comfortinnDomCIHS from 'assets/images/brandLogos/domestic/comfortinn-CI-HS-R.png'
import comfortinnDomCIIN from 'assets/images/brandLogos/domestic/comfortinn-CI-IN-R.png'
import comfortinnDomCIRE from 'assets/images/brandLogos/domestic/comfortinn-CI-RE-R.png'
import comfortinnDomCSSU from 'assets/images/brandLogos/domestic/comfortinn-CS-SU-R.png'
import econolodgeDomELAS from 'assets/images/brandLogos/domestic/econolodge-EL-AS-R.png'
import econolodgeDomELLO from 'assets/images/brandLogos/domestic/econolodge-EL-LO-R.png'
import mainstayDomMSES from 'assets/images/brandLogos/domestic/mainstay-MS-ES-R.png'
import mainstayDomMSSU from 'assets/images/brandLogos/domestic/mainstay-MS-SU-R.png'
import radissonhotelsamericasDomRAAS from 'assets/images/brandLogos/domestic/radissonhotelsamericas-RA-AS-R.png'
import radissonbluDomRBHO from 'assets/images/brandLogos/domestic/RadissonBlu600.png'
import radissoncountryinnandsuitesDomCXAS from 'assets/images/brandLogos/domestic/radissoncountryinnandsuites-CX-AS-R.png'
import radissonhotelsamericasDomRDHO from 'assets/images/brandLogos/domestic/Radisson600.png'
import radissonindividualsDomRVHO from 'assets/images/brandLogos/domestic/RadissonIndividuals600.png'
import radissonparkinnDomPDIN from 'assets/images/brandLogos/domestic/radissonparkinn-PD-IN-R.png'
import radissonparkplazaDomPKHO from 'assets/images/brandLogos/domestic/park-plaza-PK-HO-R.png'
import radissonparkplazaDomPKIN from 'assets/images/brandLogos/domestic/radissonparkplaza-PK-IN-R.png'
import radissonredDomRRHO from 'assets/images/brandLogos/domestic/radissonred-RR-HO-R.png'
import rodewayinnDomRWIN from 'assets/images/brandLogos/domestic/rodewayinn-RW-IN-R.png'
import rodewaynnDomRWAS from 'assets/images/brandLogos/domestic/rodewaynn-RW-AS-R.png'
import sleepinnDomSLAS from 'assets/images/brandLogos/domestic/sleepinn-SL-AS-R.png'
import sleepinnDomSLIN from 'assets/images/brandLogos/domestic/sleepinn-SL-IN-R.png'
import suburbanDomSBES from 'assets/images/brandLogos/domestic/suburban-SB-ES-R.png'
import woodspringDomWSSU from 'assets/images/brandLogos/domestic/woodspring-WS-SU-R.png'

// International Logos
import ascendIntlACCC from 'assets/images/brandLogos/international/AscendHotels600.png'
import cambriaIntlBRHO from 'assets/images/brandLogos/international/cambria-BR-HO-TM.png'
import clarionIntlCLAS from 'assets/images/brandLogos/international/clarion-CL-AS-TM.png'
import clarionIntlCLCC from 'assets/images/brandLogos/international/clarion-CL-CC-TM.png'
import clarionIntlCLHO from 'assets/images/brandLogos/international/clarion-CL-HO-TM.png'
import clarionIntlCLHS from 'assets/images/brandLogos/international/clarion-CL-HS-TM.png'
import clarionIntlCLIN from 'assets/images/brandLogos/international/clarion-CL-IN-TM.png'
import clarionIntlCLPT from 'assets/images/brandLogos/international/clarion-CL-PT-TM.png'
import clarionIntlCLSU from 'assets/images/brandLogos/international/clarion-CL-SU-TM.png'
import comfortinnIntlCIAS from 'assets/images/brandLogos/international/comfortinn-CI-AS-TM.png'
import comfortinnIntlCIHO from 'assets/images/brandLogos/international/comfortinn-CI-HO-TM.png'
import comfortinnIntlCIHS from 'assets/images/brandLogos/international/comfortinn-CI-HS-TM.png'
import comfortinnIntlCIIN from 'assets/images/brandLogos/international/comfortinn-CI-IN-TM.png'
import comfortinnIntlCIRE from 'assets/images/brandLogos/international/comfortinn-CI-RE-TM.png'
import comfortinnIntlCSSU from 'assets/images/brandLogos/international/comfortinn-CS-SU-TM.png'
import econolodgeIntlELAS from 'assets/images/brandLogos/international/econolodge-EL-AS-TM.png'
import econolodgeIntlELLO from 'assets/images/brandLogos/international/econolodge-EL-LO-TM.png'
import everhomeIntlEVSU from 'assets/images/brandLogos/international/everhome-EV-SU-TM.png'
import homehotelIntl from 'assets/images/brandLogos/international/homehotel-SH-HO.png'
import mainstayIntlMSES from 'assets/images/brandLogos/international/mainstay-MS-ES-TM.png'
import mainstayIntlMSSU from 'assets/images/brandLogos/international/mainstay-MS-SU-TM.png'
import qualityinnIntlQIAS from 'assets/images/brandLogos/international/qualityinn-QI-AS-TM.png'
import qualityinnIntlQIHO from 'assets/images/brandLogos/international/qualityinn-QI-HO-TM.png'
import qualityinnIntlQIHS from 'assets/images/brandLogos/international/qualityinn-QI-HS-TM.png'
import qualityinnIntlQIIN from 'assets/images/brandLogos/international/qualityinn-QI-IN-TM.png'
import qualityinnIntlQIRE from 'assets/images/brandLogos/international/qualityinn-QI-RE-TM.png'
import qualityinnIntlQISU from 'assets/images/brandLogos/international/qualityinn-QI-SU-TM.png'
import radissonhotelsamericasIntlRDHO from 'assets/images/brandLogos/international/RadissonTM600.png'
import radissoncountryinnandsuitesIntlCXAS from 'assets/images/brandLogos/international/radissoncountryinnandsuites-CX-AS-TM.png'
import radissonindividualsIntlRVHO from 'assets/images/brandLogos/international/RadissonIndividualsTM600.png'
import rodewayinnIntlRWAS from 'assets/images/brandLogos/international/rodewayinn-RW-AS-TM.png'
import rodewayinnIntlRWIN from 'assets/images/brandLogos/international/rodewayinn-RW-IN-TM.png'
import sleepinnIntlSLAS from 'assets/images/brandLogos/international/sleepinn-SL-AS-TM.png'
import sleepinnIntlSLIN from 'assets/images/brandLogos/international/sleepinn-SL-IN-TM.png'
import suburbanIntlSBST from 'assets/images/brandLogos/international/suburban-SB-ST-TM.png'
import stopoverInternational from 'assets/images/brandLogos/international/StopoverR.png'

// New brand logos
import lennaDomestic from 'assets/images/brandLogos/domestic/Lenna600.png'
import lennaInternational from 'assets/images/brandLogos/international/Lenna600.png'
import transamericaDomestic from 'assets/images/brandLogos/domestic/TransamericaHotels.png'
import transamericaInternational from 'assets/images/brandLogos/international/TransamericaHotels.png'
import byAtlanticaDomestic from 'assets/images/brandLogos/domestic/ByAtlantica.png'
import byAtlanticaInternational from 'assets/images/brandLogos/international/ByAtlantica.png'

export const BRAND_CODE_ASCEND = 'AC'
export const BRAND_CODE_CAMBRIA = 'BR'
export const BRAND_CODE_COMFORT = 'CI'
export const BRAND_CODE_CLARION = 'CL'
export const BRAND_CODE_COMFORT_SUITES = 'CS'
export const BRAND_CODE_ECONOLODGE = 'EL'
export const BRAND_CODE_EVERHOME = 'EV'
export const BRAND_CODE_MAINSTAY = 'MS'
export const BRAND_CODE_QUALITY = 'QI'
export const BRAND_CODE_RODEWAY = 'RW'
export const BRAND_CODE_SUBURBAN = 'SB'
export const BRAND_CODE_SLEEP_INN = 'SL'
export const BRAND_CODE_WOODSPRING = 'WS'
export const BRAND_CODE_COUNTRY = 'CX'
export const BRAND_CODE_RADISSON_INN_SUITE = 'RA'
export const BRAND_CODE_RADISSON = 'RD'
export const BRAND_CODE_RADISSON_BLU = 'RB'
export const BRAND_CODE_PARK_INN = 'PD'
export const BRAND_CODE_PARK_PLAZA = 'PK'
export const BRAND_CODE_RADISSON_RAD = 'RR'
export const BRAND_CODE_RADISSON_INDIVIDUALS = 'RV'
export const BRAND_CODE_RADISSON_COLLECTION = 'RC'
export const BRAND_CODE_CIRCUS_CIRCUS = 'CC'
export const BRAND_CODE_HOME = 'SH'
export const BRAND_CODE_STOPOVER = 'SS'
export const BRAND_CODE_SSAW = 'SW'
export const BRAND_CODE_LENNA_UPSCALE = 'LN'
export const BRAND_CODE_LENNA_MIDSCALE = 'LC'
export const BRAND_CODE_TRANSAMERICA = 'AT'
export const BRAND_CODE_BY_ATLANTICA = 'AA'
export const BRAND_CODE_AE = 'AE'
export const BRAND_CODE_ROCKETFUEL = 'FR'

export const BRAND_NAME_WOODSPRING = 'WoodSpring'

export const BOX_RHGA = 'RHGA'

export const BRAND_SCANDINAVIAN_REGION = 'SCA'

export const RADISSON_BRAND_CODES = [
    BRAND_CODE_COUNTRY,
    BRAND_CODE_RADISSON_INN_SUITE,
    BRAND_CODE_RADISSON,
    BRAND_CODE_RADISSON_BLU,
    BRAND_CODE_PARK_INN,
    BRAND_CODE_PARK_PLAZA,
    BRAND_CODE_RADISSON_RAD,
    BRAND_CODE_RADISSON_INDIVIDUALS,
    BRAND_CODE_RADISSON_COLLECTION
]

export const BRAND_CODES_OPTIONS = [
    { label: BRAND_CODE_ASCEND, value: BRAND_CODE_ASCEND }, 
    { label: BRAND_CODE_CAMBRIA, value: BRAND_CODE_CAMBRIA }, 
    { label: BRAND_CODE_COMFORT, value: BRAND_CODE_COMFORT }, 
    { label: BRAND_CODE_CLARION, value: BRAND_CODE_CLARION }, 
    { label: BRAND_CODE_COMFORT_SUITES, value: BRAND_CODE_COMFORT_SUITES }, 
    { label: BRAND_CODE_ECONOLODGE, value: BRAND_CODE_ECONOLODGE }, 
    { label: BRAND_CODE_EVERHOME, value: BRAND_CODE_EVERHOME }, 
    { label: BRAND_CODE_MAINSTAY, value: BRAND_CODE_MAINSTAY }, 
    { label: BRAND_CODE_QUALITY, value: BRAND_CODE_QUALITY }, 
    { label: BRAND_CODE_RODEWAY, value: BRAND_CODE_RODEWAY }, 
    { label: BRAND_CODE_SUBURBAN, value: BRAND_CODE_SUBURBAN }, 
    { label: BRAND_CODE_SLEEP_INN, value: BRAND_CODE_SLEEP_INN }, 
    { label: BRAND_CODE_WOODSPRING, value: BRAND_CODE_WOODSPRING },
    { label: BRAND_CODE_COUNTRY, value: BRAND_CODE_COUNTRY },
    { label: BRAND_CODE_RADISSON_INN_SUITE, value: BRAND_CODE_RADISSON_INN_SUITE },
    { label: BRAND_CODE_RADISSON, value: BRAND_CODE_RADISSON },
    { label: BRAND_CODE_RADISSON_BLU, value: BRAND_CODE_RADISSON_BLU },
    { label: BRAND_CODE_PARK_INN, value: BRAND_CODE_PARK_INN },
    { label: BRAND_CODE_PARK_PLAZA, value: BRAND_CODE_PARK_PLAZA },
    { label: BRAND_CODE_RADISSON_RAD, value: BRAND_CODE_RADISSON_RAD },
    { label: BRAND_CODE_RADISSON_INDIVIDUALS, value: BRAND_CODE_RADISSON_INDIVIDUALS },
    { label: BRAND_CODE_RADISSON_COLLECTION, value: BRAND_CODE_RADISSON_COLLECTION },
    { label: BRAND_CODE_CIRCUS_CIRCUS, value: BRAND_CODE_CIRCUS_CIRCUS },
    { label: BRAND_CODE_HOME, value: BRAND_CODE_HOME },
    { label: BRAND_CODE_STOPOVER, value: BRAND_CODE_STOPOVER },
    { label: BRAND_CODE_SSAW, value: BRAND_CODE_SSAW },
    { label: BRAND_CODE_LENNA_UPSCALE, value: BRAND_CODE_LENNA_UPSCALE },
    { label: BRAND_CODE_LENNA_MIDSCALE, value: BRAND_CODE_LENNA_MIDSCALE },
    { label: BRAND_CODE_TRANSAMERICA, value: BRAND_CODE_TRANSAMERICA },
    { label: BRAND_CODE_BY_ATLANTICA, value: BRAND_CODE_BY_ATLANTICA },
    { label: BRAND_CODE_AE, value: BRAND_CODE_AE },
    { label: BRAND_CODE_ROCKETFUEL, value: BRAND_CODE_ROCKETFUEL }
]

export const BRAND_TYPE_DOMESTIC = 'domestic'
export const BRAND_TYPE_INTERNATIONAL = 'international'

export const BRAND_LOGOS = {
    'international': {
        // TODO: Change this after getting the new logos
        [BRAND_CODE_ASCEND]: ascendhotelcollectionInternational,
        [BRAND_CODE_CAMBRIA]: cambriaInternational,
        [BRAND_CODE_CLARION]: clarionInternational,
        [BRAND_CODE_COMFORT_SUITES]: comfortDomestic,
        [BRAND_CODE_ECONOLODGE]: econolodgeInternational,
        [BRAND_CODE_EVERHOME]: everhomeDomestic,
        [BRAND_CODE_MAINSTAY]: mainstayInternational,
        [BRAND_CODE_QUALITY]: qualityInternational,
        [BRAND_CODE_RODEWAY]: rodewayinnInternational,
        [BRAND_CODE_SLEEP_INN]: sleepinnInternational,
        [BRAND_CODE_RADISSON] : radissonInternational,
        [BRAND_CODE_STOPOVER] : stopoverInternational,
        [BRAND_CODE_SSAW] : ascendhotelcollectionInternational,
        [BRAND_CODE_LENNA_UPSCALE]: ascendhotelcollectionInternational,
        [BRAND_CODE_LENNA_MIDSCALE]: lennaInternational,
        [BRAND_CODE_TRANSAMERICA]: transamericaInternational,
        [BRAND_CODE_BY_ATLANTICA]: byAtlanticaInternational
    },
    'domestic': {
        [BRAND_CODE_ASCEND]: ascendDomestic,
        [BRAND_CODE_CAMBRIA]: cambriaDomestic,
        [BRAND_CODE_COMFORT]: comfortDomestic,
        [BRAND_CODE_CLARION]: clarionDomestic,
        [BRAND_CODE_COMFORT_SUITES]: comfortSuitesDomestic,
        [BRAND_CODE_ECONOLODGE]: econolodgeDomestic,
        [BRAND_CODE_EVERHOME]: everhomeDomestic,
        [BRAND_CODE_MAINSTAY]: mainstayDomestic,
        [BRAND_CODE_QUALITY]: qualityDomestic,
        [BRAND_CODE_RODEWAY]: rodewayDomestic,
        [BRAND_CODE_SUBURBAN]: suburbanDomestic,
        [BRAND_CODE_SLEEP_INN]: sleepDomestic,
        [BRAND_CODE_WOODSPRING]: woodspringDomestic,
        [BRAND_CODE_RADISSON] : radissonDomestic,
        [BRAND_CODE_LENNA_UPSCALE]: ascendDomestic,
        [BRAND_CODE_LENNA_MIDSCALE]: lennaDomestic,
        [BRAND_CODE_TRANSAMERICA]: transamericaDomestic,
        [BRAND_CODE_BY_ATLANTICA]: byAtlanticaDomestic
    }
}

export const BRAND_PRODUCT_LOGOS = {
    'international': {
        'AC_CC' : ascendIntlACCC,
        'BR_HO' : cambriaIntlBRHO,
        'CI_AS' : comfortinnIntlCIAS,
        'CI_HO' : comfortinnIntlCIHO,
        'CI_HS' : comfortinnIntlCIHS,
        'CI_IN' : comfortinnIntlCIIN,
        'CI_RE' : comfortinnIntlCIRE,
        'CL_AS' : clarionIntlCLAS,
        'CL_CC' : clarionIntlCLCC,
        'CL_HO' : clarionIntlCLHO,
        'CL_HS' : clarionIntlCLHS,
        'CL_IN' : clarionIntlCLIN,
        'CL_PT' : clarionIntlCLPT,
        'CL_SU' : clarionIntlCLSU,
        'CS_SU' : comfortinnIntlCSSU,
        'CX_AS' : radissoncountryinnandsuitesIntlCXAS,
        'EL_AS' : econolodgeIntlELAS,
        'EL_LO' : econolodgeIntlELLO,
        'EV_SU' : everhomeIntlEVSU,
        'MS_ES' : mainstayIntlMSES,
        'MS_SU' : mainstayIntlMSSU,
        'QI_AS' : qualityinnIntlQIAS,
        'QI_HO' : qualityinnIntlQIHO,
        'QI_HS' : qualityinnIntlQIHS,
        'QI_IN' : qualityinnIntlQIIN,
        'QI_RE' : qualityinnIntlQIRE,
        'QI_SU' : qualityinnIntlQISU,
        'RD_HO' : radissonhotelsamericasIntlRDHO,
        'RV_HO' : radissonindividualsIntlRVHO,
        'RW_AS' : rodewayinnIntlRWAS,
        'RW_IN' : rodewayinnIntlRWIN,
        'SB_ST' : suburbanIntlSBST,
        'SS_HO' : stopoverInternational,
        'SW_HO' : ascendIntlACCC,
        'SH_HO' : homehotelIntl,
        'SL_AS' : sleepinnIntlSLAS,
        'SL_IN' : sleepinnIntlSLIN
    },
    'domestic': {
        'AC_HO' : ascendDomACHO,
        'BR_HO' : cambriaDomBRHO,
        'CI_AS' : comfortinnDomCIAS,
        'CI_HO' : comfortinnDomCIHO,
        'CI_HS' : comfortinnDomCIHS,
        'CI_IN' : comfortinnDomCIIN,
        'CI_RE' : comfortinnDomCIRE,
        'CL_AS' : clarionDomCLAS,
        'CL_CC' : clarionDomCLCC,
        'CL_HO' : clarionDomCLHO,
        'CL_HS' : clarionDomCLHS,
        'CL_IN' : clarionDomCLIN,
        'CL_PT' : clarionDomCLPT,
        'CL_SU' : clarionDomCLSU,
        'CS_SU' : comfortinnDomCSSU,
        'CX_AS' : radissoncountryinnandsuitesDomCXAS,
        'EL_AS' : econolodgeDomELAS,
        'EL_LO' : econolodgeDomELLO,
        'MS_ES' : mainstayDomMSES,
        'MS_SU' : mainstayDomMSSU,
        'PD_IN' : radissonparkinnDomPDIN,
        'PK_HO' : radissonparkplazaDomPKHO,
        'PK_IN' : radissonparkplazaDomPKIN,
        'RA_AS' : radissonhotelsamericasDomRAAS,
        'RB_HO' : radissonbluDomRBHO,
        'RD_HO' : radissonhotelsamericasDomRDHO,
        'RR_HO' : radissonredDomRRHO,
        'RV_HO' : radissonindividualsDomRVHO,
        'RW_AS' : rodewaynnDomRWAS,
        'RW_IN' : rodewayinnDomRWIN,
        'SB_ES' : suburbanDomSBES,
        'SL_AS' : sleepinnDomSLAS,
        'SL_IN' : sleepinnDomSLIN,
        'WS_SU' : woodspringDomWSSU
    }
}